import { createHash } from 'modules/handlebars/domain/hash/utils';
import { createPathExpression } from 'modules/handlebars/domain/expression/utils';
import { createContentStatement } from 'modules/handlebars/domain/statement/utils';
import { createProgram } from 'modules/handlebars/domain/program/utils';
import { createSubExpressionsFromConditons } from './createSubExpressionsFromConditions';
import { Combinator, ConditionalContent } from '../../domain';

/** gets block statement args from if clause */
export const createBlockStatementConfigFromConditionalContent = (
  conditionalContent: ConditionalContent,
) => {
  const {
    ifClause: { conditions, combinator = Combinator.AND, content = '' },
  } = conditionalContent;

  /** creates hash, path, and params */
  const hash = createHash();
  const path = createPathExpression(combinator);
  const params = createSubExpressionsFromConditons(conditions);

  /** creates program */
  const programStatements = [createContentStatement(content)];
  const program = createProgram({ body: programStatements });

  return { hash, path, params, program };
};
